import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {logoutUser} from "../../actions/auth";

function Logout () {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;

    (async () => {
      await dispatch(logoutUser());
      if (mounted) {
        navigate('/login', { replace: true });
      }
    })();

    return () => {
      mounted = false;
    };
  }, [dispatch, navigate]);

  return null;
}
export default Logout;
